import { LoadingState as ExoLoadingState } from "@exopengithub/exokit";
import type { ComponentProps } from "react";
import { useTranslation } from "react-i18next";

// Portal wrapper: injects the Swedish default label; ExoKit's LoadingState is
// i18n-agnostic (defaults to English).
export const LoadingState = (props: ComponentProps<typeof ExoLoadingState>) => {
	const { t } = useTranslation();
	return <ExoLoadingState label={t("Loading")} {...props} />;
};
